export default __webpack_public_path__ + "static/media/impedeessence.7c4d82f2.png";